import { PortType } from '../index'

export const nodeType = 'backend-systems-node'

export function buildBackendSystemPortName(
  index: number,
  portType: PortType
): string {
  return `backend-system-port-${portType}-${index}`
}
